import * as React from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { closeAlert } from "../../actions";
import { RootState } from "../../store";

export interface ModalFormProps {
    modalStateIsOpen?: boolean | string
    openModal?: (arg: any) => void
    closeModal?: () => void
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '40%'
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.35)',
        zIndex: 9999
    }
};

const ModalAlert = () => {

    const {modal, content} = useSelector((state: RootState) => state.modal)
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(closeAlert());
    }

    return <Modal
        isOpen={modal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Modal window"
        ariaHideApp={false}
        className="modal-content react-bs-table-insert-modal"
    >
        <div className="modal-header">
            <button type="button" className="close" onClick={closeModal}><span aria-hidden="true">×</span></button>
            <h4 className="modal-title">
                {content === 'Запрос отправлен' ? 'Запрос на отсрочку отчёта' : 'Произошла ошибка'}
            </h4>
            </div>
        <div className="modal-body">
            <div dangerouslySetInnerHTML={{__html: content}} />
        </div>
        <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={closeModal}>Закрыть</button>
        </div>
    </Modal>
}

export default ModalAlert;


// WEBPACK FOOTER //
// ./src/components/modal/index.tsx